import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import CommonGridHeader, { CommonEditButton } from "../../../Components/Common Components/CommonComponents";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";
import { CheckAccessFunc, formatDate } from "../../../Components/CommonFunctions/CommonFunctions";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { Colors } from "../../../Styles/Colors";

// ✅ Make sure you add this in Serviceurls:
// export const JMO_NURSE_PROFILE = "core/nurse/";  (example)
const NURSE_URL = Serviceurls.NURSE_URL;

export default function NurseManagement() {
  const [tblItem, settblItem] = useState({
    nurseList: [],
    tblLoader: false,
    page: 0,
    rowsPerPage: 10,
    search_key: "",
  });

  const [nurseValues, setNurseValues] = useState({
    first_name: "",
    gender: "",
    is_active: true,
    isEdit: false,
    editID: null,
  });

  const [message, setMessage] = useState({
    isErrorMsgText: "",
    successMsgText: "",
    isErrorMsg: false,
    successMsg: false,
  });

  useEffect(() => {
    nurseGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const errorMessage = (msg) => {
    setMessage((prev) => ({
      ...prev,
      isErrorMsg: true,
      isErrorMsgText: msg,
    }));
  };

  const successMessage = (msg) => {
    setMessage((prev) => ({
      ...prev,
      successMsg: true,
      successMsgText: msg,
    }));
  };

  const msgClose = () => {
    setMessage({
      isErrorMsgText: "",
      successMsgText: "",
      isErrorMsg: false,
      successMsg: false,
    });
  };

  const handleClear = () => {
    setNurseValues({
      first_name: "",
      gender: "",
      is_active: true,
      isEdit: false,
      editID: null,
    });
  };

  const nurseGet = () => {
    try {
      settblItem((prev) => ({ ...prev, tblLoader: true }));

      const url =
        tblItem.search_key?.trim()
          ? `${NURSE_URL}?search_key=${encodeURIComponent(tblItem.search_key.trim())}`
          : NURSE_URL;

      RestAPIService.getAll(url)
        .then((response) => {
          if (response?.data?.status === "success") {
            const rows = response.data.data || [];
            // create sno
            rows.forEach((el, idx) => (el.sno = idx + 1));

            settblItem((prev) => ({
              ...prev,
              nurseList: rows,
              tblLoader: false,
            }));
          } else {
            settblItem((prev) => ({ ...prev, tblLoader: false }));
          }
        })
        .catch((e) => {
          settblItem((prev) => ({ ...prev, tblLoader: false }));
          errorMessage(e?.response?.data?.message || e.message);
        });
    } catch (e) {
      errorMessage(e.message);
    }
  };

  // Backend uses POST for both Create & Update (id decides update)
  const nursePost = () => {
    try {
      settblItem((prev) => ({ ...prev, tblLoader: true }));

      const payload = {
        ...(nurseValues.isEdit && nurseValues.editID ? { nurse_id: nurseValues.editID } : {}),
        first_name: nurseValues.first_name || "",
        gender: nurseValues.gender === 'Male' ? 'M' : nurseValues.gender === 'Female' ? 'F' : 'T',
        is_active: nurseValues.is_active ? true : false,

      };

      RestAPIService.create(payload, NURSE_URL)
        .then((response) => {
          if (response?.data?.status === "success") {
            successMessage(response.data.message || "Saved Successfully");
            settblItem((prev) => ({ ...prev, tblLoader: false }));
            handleClear();
            nurseGet();
          } else {
            settblItem((prev) => ({ ...prev, tblLoader: false }));
          }
        })
        .catch((e) => {
          settblItem((prev) => ({ ...prev, tblLoader: false }));
          errorMessage(e?.response?.data?.message || e.message);
        });
    } catch (e) {
      errorMessage(e.message);
    }
  };


  // const nursePut = (id) => {
  //   try {
  //     settblItem((prev) => ({ ...prev, tblLoader: true }));
  //     const data = {
  //       first_name: nurseValues.first_name || "",
  //       gender: nurseValues.gender === 'Male' ? 'M' : nurseValues.gender === 'Female' ? 'F' : 'T',
  //       is_active: nurseValues.is_active,
  //       // nurse_id: nurseList.nurse_id,
  //     };
  //         console.log("Update payload:", data);
  //   console.log("Update URL:", Serviceurls.NURSE_URL);
  //     RestAPIService.updateWithOutId(data, NURSE_URL)
  //       .then((response) => {
  //         if (response?.data?.status === "success") {
  //           successMessage(response.data.message || "Updated Successfully");
  //           settblItem((prev) => ({ ...prev, tblLoader: false }));
  //           nurseGet();
  //         } else {
  //           settblItem((prev) => ({ ...prev, tblLoader: false }));
  //         } })
  //       .catch((e) => {
  //         settblItem((prev) => ({ ...prev, tblLoader: false }));
  //         errorMessage(e?.response?.data?.message || e.message);
  //       }); 
  //   } catch (e) {
  //     errorMessage(e.message);
  //   }
  // };


  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value?.trimStart?.() ?? event.target.value;

    let updatedValues = { ...nurseValues };

    switch (name) {
      case "first_name": {
        const isValid = CommonValidation.alphabetOnly(value);
        if (value === "" || (isValid && value.length <= 50)) {
          updatedValues[name] = value;
          setNurseValues(updatedValues);
        }
        return;
      }
      default:
        updatedValues[name] = value;
        setNurseValues(updatedValues);
        return;
    }
  };

  const validationCheck = () => {
    if (!nurseValues.first_name) return errorMessage("Please Enter Nurse Name");
    if (!nurseValues.gender) return errorMessage("Please Select Gender");
    nursePost();
  };

  const renderTextBox = (label, statekey, value) => {
    const gender_list = [
      { label: "Male", value: "Male" },
      { label: "Female", value: "Female" },
      { label: "Other", value: "Other" },
    ];

    return (
      <Box>
        {statekey === "gender" ? (
          <FormControl sx={{ width: "15vw" }} size="small">
            <InputLabel>{label + " *"}</InputLabel>
            <Select
              value={value ? value : ""}
              name={statekey}
              label={label + " *"}
              onChange={(event) => setNurseValues({ ...nurseValues, gender: event.target.value })}
            >
              {gender_list.map((g, index) => (
                <MenuItem key={index} value={g.value}>
                  {g.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <TextField
            sx={{ width: "15vw" }}
            autoComplete="off"
            required
            size="small"
            label={label + " *"}
            name={statekey}
            value={value ? value : ""}
            onChange={handleChange}
          />
        )}
      </Box>
    );
  };

  const columns = [
    { field: "sno", headerName: "S.No", sortable: false, flex: 0.07 },
    {
      field: "first_name",
      headerName: "Nurse Name",
      flex: 0.25,
      renderCell: (cellvalues) => (
        <Box>
          {cellvalues?.row?.nurse_name?.length > 15 ? (
            <Tooltip placement="top" title={cellvalues?.row?.nurse_name} arrow>
              <Typography fontSize={".9vw"}>
                {cellvalues?.row?.nurse_name.slice(0, 10) + "..."}
              </Typography>
            </Tooltip>
          ) : (
            <Typography fontSize={".9vw"}>{cellvalues?.row?.nurse_name || "-"}</Typography>
          )}
        </Box>
      ),
    },
    {
      field: "gender",
      headerName: "Gender",
      flex: 0.15,
      headerAlign: "center",
      align: "center",
      renderCell: (cellvalues) => (
        <Typography fontSize={".9vw"}>{cellvalues?.row?.gender || "-"}</Typography>
      ),
    },
    {
      field: "created_date",
      headerName: "Created Date",
      flex: 0.18,
      headerAlign: "center",
      align: "center",
      renderCell: (cellvalues) => (
        <Typography fontSize={".9vw"}>
          {formatDate(cellvalues?.row?.created_date) || "-"}
        </Typography>
      ),
    },
    {
      field: "is_active",
      headerName: "Active",
      flex: 0.12,
      headerAlign: "center",
      align: "center",
      renderCell: (cellvalues) => (
        <Typography fontSize={".9vw"}>{cellvalues?.row?.is_active === true ? "Yes" : "No"}</Typography>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      flex: 0.23,
      headerAlign: "center",
      align: "center",
      renderCell: (cellvalues) => (
        <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
          <CommonEditButton
            size="1.5vw"
            onClick={() => {
              setNurseValues({
                first_name: cellvalues?.row?.nurse_name || "",
                gender: cellvalues?.row?.gender || "",
                is_active: !!cellvalues?.row?.is_active,
                isEdit: true,
                editID: cellvalues?.row?.nurse_id || null,
              });
            }}
          />

        </Stack>
      ),
    },
  ];

  return (
    <Box id="eMed_srvConfig_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
      <Grid container spacing={3} className="eMed_srvConfig_Box">
        <Grid item xs={7.6}>
          <Paper className="eMed_srvConfig_Div">
            <DataGrid
              rows={tblItem.nurseList}
              columns={columns}
              getRowId={(row) => row.sno}
              localeText={{
                toolbarColumns: "",
                toolbarDensity: "",
                toolbarExport: "",
                toolbarFilters: "",
                toolbarExportPrint: "",
              }}
              disableSelectionOnClick
              components={{
                Toolbar: CommonGridHeader.CommonToolBar,
                NoRowsOverlay: () => (
                  <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                    {"No Records to Be Shown"}
                  </Stack>
                ),
              }}
              headerHeight={40}
              rowCount={tblItem.nurseList.length}
              page={tblItem.page}
              onPageChange={(newPage) => settblItem((prev) => ({ ...prev, page: newPage }))}
              pageSize={tblItem.rowsPerPage}
              onPageSizeChange={(newPageSize) => settblItem((prev) => ({ ...prev, rowsPerPage: newPageSize }))}
              rowsPerPageOptions={[10, 20, 30]}
              pagination
              loading={tblItem.tblLoader}
            />
          </Paper>
        </Grid>

        <Grid item xs={4.4}>
          <Paper className="eMed_srvConfig_Div">
            <Box className="eMed_srvConfig_rightHead" style={{ backgroundColor: Colors.DataTblHeaderbg }}>
              <Typography sx={{ fontWeight: 600, marginLeft: "1.5vw", color: "#616161" }}>
                {"Nurse Management"}
              </Typography>
            </Box>

            <Box className="eMed_srvConfig_subDiv" sx={{ padding:'1vw' }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                {renderTextBox("Nurse Name", "first_name", nurseValues.first_name)}
                {renderTextBox("Gender", "gender", nurseValues.gender)}
              </Stack>

              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box sx={{ width: "15vw" }}>
                  <FormControlLabel
                    label="Active"
                    labelPlacement="start"
                    sx={{ gap: "1vw" }}
                    control={
                      <Checkbox
                        checked={nurseValues.is_active ? true : false}
                        onChange={(e) => setNurseValues({ ...nurseValues, is_active: e.target.checked })}
                      />
                    }
                  />
                </Box>
              </Stack>
            </Box>

            <Stack
              spacing={2}
              direction="row"
              id="eMed_srvConfig_rightBtnCon"
              sx={{ backgroundColor: Colors.DataTblHeaderbg }}
              alignItems="center"
              justifyContent="center"
            >
              <Button variant="outlined" size="small" id="eMed_Config_btn" onClick={handleClear}>
                {"Clear"}
              </Button>

              <Button
                variant="contained"
                disabled={
                  !CheckAccessFunc("front_office", "Settings", "Hospital Configuration", "Nurse Management", "SubTab")
                    ?.editAccess || tblItem.tblLoader
                }
                size="small"
                id="eMed_Config_btn"
                onClick={nurseValues.isEdit ? () => nursePost() : validationCheck}
              >
                {nurseValues.isEdit ? "Update" : "Save"}
              </Button>
            </Stack>
          </Paper>
        </Grid>
      </Grid>

      {message.isErrorMsg ? (
        <ToastMsg severity={"error"} msg={message.isErrorMsgText} msgPop={msgClose} />
      ) : null}

      {message.successMsg ? (
        <ToastMsg severity={"success"} msg={message.successMsgText} msgPop={msgClose} />
      ) : null}
    </Box>
  );
}
